var _style, _polygon, _rect, _rect2, _rect3, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect4, _rect5, _polygon7, _g, _polygon8, _rect6, _g2, _rect7, _path, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _g3, _polygon16, _path2, _polygon17, _g4, _path3, _g5, _rect8, _polygon18, _path4, _polygon19, _g6, _polygon20, _g7, _polygon21, _polygon22, _g8, _polygon23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEsch2022(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 146.2",
    style: {
      enableBackground: "new 0 0 210 146.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00B5AF;}\n\t.st1{fill:#EE3124;}\n\t.st2{fill:#571D0C;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0 0,74.9 15,74.9 15,15 60,15 60,0 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 59.9,
    className: "st1",
    width: 60,
    height: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    className: "st1",
    width: 60,
    height: 15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 59.9,
    className: "st2",
    width: 15,
    height: 15
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75,0 75,15 120,15 120,30 135,30 135,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "150,0 150,15 195,15 195,30 150,30 150,45 210,45 210,0 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150,44.9 150,74.9 210,74.9 210,59.9 165,59.9 165,44.9 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90,59.9 90,44.9 75,44.9 75,74.9 135,74.9 135,59.9 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "120,30 75,30 75,45 90,45 120,45 135,45 135,30 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    className: "st2",
    width: 15,
    height: 15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 29.9,
    className: "st2",
    width: 15,
    height: 15
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4.4,94.8 4.4,97.8 9.9,97.8 9.9,100.5 4.4,100.5 4.4,103.7 11.4,103.7 11.4,106.6 1,106.6 1,92  11.4,92 11.4,94.8 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.2,96.2c-0.4-1.2-1.2-1.7-2.5-1.7c-0.9,0-2,0.2-2,1.4c0,1.1,1.3,1.3,2.1,1.5c1.2,0.3,2.8,0.5,3.8,1.2 c1.2,0.8,1.9,2,1.9,3.4s-0.7,2.8-1.8,3.6c-1.2,0.9-2.8,1.2-4.2,1.2c-2.7,0-5.2-1.2-5.9-4l3.1-0.7c0.4,1.5,1.5,2.1,3,2.1 c1,0,2.3-0.4,2.3-1.6s-1.7-1.4-2.5-1.6c-2.6-0.5-5.1-1.3-5.1-4.5c0-1.4,0.5-2.5,1.6-3.4s2.3-1.2,3.6-1.2c2.5,0,4.6,0.9,5.5,3.4 L22.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,97.7c0-1.6-0.6-3.1-2.4-3.1c-2.4,0-2.6,3.1-2.6,4.9c0,2,0.2,4.6,2.8,4.6c1.6,0,2.3-1.3,2.5-2.7l3.3,0.2 c-0.4,3.3-2.6,5.3-6,5.3c-4.3,0-6.4-3.5-6.4-7.5s2.2-7.5,6.5-7.5c3.6,0,5.5,2.1,5.9,5.6L37,97.7z"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.2,106.6 51.8,106.6 51.8,100.6 47.3,100.6 47.3,106.6 43.9,106.6 43.9,92 47.3,92 47.3,97.7  51.8,97.7 51.8,92 55.2,92 "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 99.9,
    className: "st1",
    width: 5,
    height: 2.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.2,96.2c-0.4-1.2-1.2-1.7-2.5-1.7c-0.9,0-2,0.2-2,1.4c0,1.1,1.3,1.3,2.1,1.5c1.2,0.3,2.8,0.5,3.8,1.2 c1.2,0.8,1.9,2,1.9,3.4s-0.7,2.8-1.8,3.6c-1.2,0.9-2.8,1.2-4.2,1.2c-2.7,0-5.2-1.2-5.9-4l3.1-0.7c0.4,1.5,1.5,2.1,3,2.1 c1,0,2.3-0.4,2.3-1.6s-1.7-1.4-2.5-1.6c-2.6-0.5-5.1-1.3-5.1-4.5c0-1.4,0.5-2.5,1.6-3.4s2.3-1.2,3.6-1.2c2.5,0,4.6,0.9,5.5,3.4 L74.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.2,100.8c0,1.6,0,3.2-1.2,4.4c-1.2,1.2-2.9,1.5-4.5,1.5c-1.5,0-3.3-0.2-4.4-1.2c-1.4-1.2-1.5-2.9-1.5-4.7 V92h3.7v8.8c0,0.7,0,1.7,0.3,2.2c0.4,0.8,1.4,1,2.2,1c0.7,0,1.7-0.2,2.1-0.8c0.5-0.7,0.4-1.7,0.4-2.4V92h2.9V100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.5,106.6h-3.4V92.1h6.1c1.3,0,2.6,0,3.7,0.7c1.2,0.8,1.8,2.2,1.8,3.6c0,1.7-1,3.2-2.5,3.7l2.7,6.4h-3.8 l-2.2-5.7h-2.4V106.6z M99.5,98.3h1.9c0.7,0,1.5,0.1,2.1-0.3c0.6-0.3,0.8-1,0.8-1.7c0-0.6-0.3-1.2-0.8-1.5 c-0.6-0.4-1.5-0.3-2.2-0.3h-1.8V98.3z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 99.9,
    className: "st1",
    width: 5,
    height: 2.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130,106.6h-3.7l-0.9-3h-4.7l-0.9,3h-3l4.7-14.5h3.9L130,106.6z M124.6,100.9l-1.5-5.1l-1.5,5.1H124.6z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "142,103.7 142,106.6 132.7,106.6 132.7,92 136.1,92 136.1,103.7 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "148.9,103.8 156.5,103.8 156.5,106.6 144.7,106.6 144.7,104.1 152.1,94.8 145.3,94.8 145.3,92  156.2,92 156.2,94.5 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "163.1,94.8 163.1,97.8 168.7,97.8 168.7,100.5 163.1,100.5 163.1,103.7 170.1,103.7 170.1,106.6  159.8,106.6 159.8,92 170.1,92 170.1,94.8 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "183.3,94.9 179.6,94.9 179.6,106.6 176.2,106.6 176.2,94.9 172.6,94.9 172.6,92 183.3,92 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "196.3,94.9 192.7,94.9 192.7,106.6 189.3,106.6 189.3,94.9 185.6,94.9 185.6,92 196.3,92 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "199.2,92 199.2,106.6 209.6,106.6 209.6,103.7 202.6,103.7 202.6,100.5 208.1,100.5 208.1,97.8  202.6,97.8 202.6,94.8 209.6,94.8 209.6,92 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4.5,114.4 4.5,117.4 10.1,117.4 10.1,120.2 4.5,120.2 4.5,123.4 11.6,123.4 11.6,126.3 1,126.3  1,111.6 11.6,111.6 11.6,114.4 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.1,120.5c0,1.6,0,3.3-1.2,4.5s-2.9,1.5-4.5,1.5c-1.5,0-3.3-0.2-4.5-1.3c-1.5-1.3-1.5-3-1.5-4.8v-8.8h3.7 v8.9c0,0.7,0,1.7,0.3,2.3c0.5,0.8,1.4,1,2.2,1c0.7,0,1.7-0.2,2.1-0.8c0.5-0.7,0.4-1.7,0.4-2.5v-8.9h3V120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.1,126.3h-3.4v-14.7h6.2c1.3,0,2.6,0,3.8,0.8s1.9,2.2,1.9,3.7c0,1.7-1,3.2-2.6,3.8l2.7,6.5h-3.8l-2.3-5.8 h-2.5L33.1,126.3L33.1,126.3z M33.1,117.9H35c0.7,0,1.5,0.1,2.1-0.3c0.6-0.3,0.9-1,0.9-1.7c0-0.6-0.3-1.2-0.8-1.5 c-0.6-0.4-1.6-0.3-2.2-0.3h-1.8L33.1,117.9L33.1,117.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.4,124.2c-1.1-1.5-1.5-3.4-1.5-5.3c0-3.9,2-7.6,6.3-7.6c2,0,3.5,0.6,4.7,2.3c1.1,1.4,1.6,3.5,1.6,5.3 c0,1.7-0.5,3.7-1.4,5.1c-1.1,1.7-2.9,2.5-4.9,2.5C48.2,126.5,46.5,125.8,45.4,124.2 M47.9,115.8c-0.3,0.9-0.5,2.1-0.5,3.1 c0,1.8,0.3,4.8,2.7,4.8c1.2,0,1.8-0.6,2.2-1.7c0.3-0.9,0.4-2.1,0.4-3.1c0-1.1-0.1-2.3-0.5-3.3s-1.1-1.4-2.1-1.4 C49,114.2,48.3,114.8,47.9,115.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,126.3h-3.4v-14.7H65c1.4,0,2.8,0,4,0.8c1.2,0.9,1.9,2.1,1.9,3.7c0,1.4-0.5,2.8-1.6,3.7 c-1.3,1.1-2.6,1-4.2,1h-2.2L62.9,126.3L62.9,126.3z M64.8,118.2c0.8,0,1.5,0,2.1-0.6c0.3-0.4,0.5-0.8,0.5-1.3 c0-0.6-0.2-1.2-0.7-1.5c-0.5-0.4-1.2-0.4-1.9-0.4h-1.9v3.9h1.9V118.2z"
  }))), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "76.9,114.4 76.9,117.4 82.5,117.4 82.5,120.2 76.9,120.2 76.9,123.4 84,123.4 84,126.3 73.4,126.3  73.4,111.6 84,111.6 84,114.4 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.3,126.3h-3.8l-0.9-3h-4.8l-0.9,3h-3l4.7-14.7h4L99.3,126.3z M93.9,120.6l-1.6-5.2l-1.6,5.2H93.9z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "113,126.3 110.1,126.3 104.4,116.4 104.3,116.4 104.3,126.3 101.7,126.3 101.7,111.6 105.4,111.6  110.3,120.2 110.4,120.2 110.4,111.6 113,111.6 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.3,117.3c0-1.6-0.6-3.2-2.5-3.2c-2.4,0-2.7,3.2-2.7,5c0,2,0.2,4.6,2.8,4.6c1.6,0,2.4-1.4,2.6-2.8l3.4,0.2 c-0.4,3.4-2.7,5.4-6.1,5.4c-4.4,0-6.5-3.6-6.5-7.6c0-4.1,2.2-7.6,6.6-7.6c3.7,0,5.6,2.1,6,5.7L132.3,117.3z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.7,126.3H147l-0.9-3h-4.8l-0.9,3h-3l4.7-14.7h4L150.7,126.3z M145.3,120.6l-1.6-5.2l-1.6,5.2H145.3z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.6,126.3h-3.4v-14.7h5.5c1.4,0,2.8,0,4,0.8c1.2,0.9,1.9,2.1,1.9,3.7c0,1.4-0.5,2.8-1.6,3.7 c-1.3,1.1-2.6,1-4.2,1h-2.2L156.6,126.3L156.6,126.3z M158.5,118.2c0.8,0,1.5,0,2.1-0.6c0.3-0.4,0.5-0.8,0.5-1.3 c0-0.6-0.2-1.2-0.7-1.5c-0.5-0.4-1.2-0.4-1.9-0.4h-1.9v3.9h1.9V118.2z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 111.6,
    className: "st2",
    width: 3.4,
    height: 14.7
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "184,114.5 180.3,114.5 180.3,126.3 176.8,126.3 176.8,114.5 173.1,114.5 173.1,111.6 184,111.6 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.3,126.3h-3.7l-0.9-3h-4.8l-0.9,3h-3l4.7-14.7h4L197.3,126.3z M191.9,120.6l-1.6-5.2l-1.6,5.2H191.9z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "199.7,111.6 199.7,126.3 209,126.3 209,123.4 203.1,123.4 203.1,111.6 "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,143.9c-1.1-1.5-1.5-3.4-1.5-5.3c0-3.9,2-7.6,6.3-7.6c2,0,3.5,0.6,4.7,2.3c1.1,1.4,1.6,3.5,1.6,5.3 c0,1.7-0.5,3.7-1.4,5.1c-1.1,1.7-2.9,2.5-4.9,2.5C4.7,146.2,3.1,145.6,2,143.9 M4.5,135.6c-0.3,0.9-0.5,2.1-0.5,3.1 c0,1.8,0.3,4.8,2.7,4.8c1.2,0,1.8-0.6,2.2-1.7c0.3-0.9,0.4-2.1,0.4-3.1c0-1.1-0.1-2.3-0.5-3.3S7.7,134,6.7,134 C5.6,133.9,4.9,134.5,4.5,135.6"
  }))), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16,131.3 16,146 19.5,146 19.5,140.3 25.1,140.3 25.1,137.5 19.5,137.5 19.5,134.2 26.5,134.2  26.5,131.3 "
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,137c0-1.6-0.6-3.2-2.5-3.2c-2.4,0-2.7,3.2-2.7,5c0,2,0.2,4.6,2.8,4.6c1.6,0,2.4-1.4,2.6-2.8l3.3,0.2 c-0.4,3.4-2.7,5.4-6.1,5.4c-4.4,0-6.5-3.6-6.5-7.6c0-4.1,2.2-7.6,6.6-7.6c3.7,0,5.6,2.1,6,5.7L44.1,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.3,140.2c0,1.6,0,3.3-1.2,4.5s-2.9,1.5-4.5,1.5c-1.5,0-3.3-0.2-4.5-1.3c-1.5-1.3-1.5-3-1.5-4.8v-8.9h3.7 v8.9c0,0.7,0,1.7,0.3,2.3c0.5,0.8,1.4,1,2.2,1c0.7,0,1.7-0.2,2.1-0.8c0.5-0.7,0.4-1.7,0.4-2.5v-8.9h3V140.2z"
  }))), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "65.8,131.3 65.8,146 75.2,146 75.2,143.1 69.3,143.1 69.3,131.3 "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "75.1,131.3 75.1,134.2 78.8,134.2 78.8,146 82.3,146 82.3,134.2 86,134.2 86,131.3 "
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.1,140.2c0,1.6,0,3.3-1.2,4.5s-2.9,1.5-4.5,1.5c-1.5,0-3.3-0.2-4.5-1.3c-1.5-1.3-1.5-3-1.5-4.8v-8.9h3.7 v8.9c0,0.7,0,1.7,0.3,2.3c0.5,0.8,1.4,1,2.2,1c0.7,0,1.7-0.2,2.1-0.8c0.5-0.7,0.4-1.7,0.4-2.5v-8.9h3V140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.1,146h-3.4v-14.7h6.2c1.3,0,2.6,0,3.8,0.8c1.2,0.8,1.9,2.2,1.9,3.7c0,1.7-1,3.2-2.6,3.8l2.7,6.5h-3.8 l-2.3-5.8h-2.5L107.1,146L107.1,146z M107.1,137.7h1.9c0.7,0,1.5,0.1,2.1-0.3c0.6-0.3,0.9-1,0.9-1.7c0-0.6-0.3-1.2-0.8-1.5 c-0.6-0.4-1.6-0.3-2.2-0.3h-1.8v3.8H107.1z"
  }))), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "118.6,131.3 118.6,146 129.1,146 129.1,143.2 122,143.2 122,139.9 127.6,139.9 127.6,137.1 122,137.1  122,134.2 129.1,134.2 129.1,131.3 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEsch2022);
export default __webpack_public_path__ + "static/media/logo_esch2022.bdcb75640bf243e403f121797571ed86.svg";
export { ForwardRef as ReactComponent };